<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect
        :is-picked-facility="true"
        :hide-select-one="true"
      ></BaseFacilitySelect>
    </div>
    <div>
      <p>
        This facility registered their intent to participate in <a href="https://www.health.state.mn.us/diseases/respiratory/hcp/respsafe.html"><u>RespSafe</u></a>  on {{date.toDateString()}}.
      </p>
      <p>
        A confirmation email will be sent to the listed primary contact.
      </p>
      <br>
      <p>
        Questions about the RespSafe program should be sent to <a href="mailto:Health.RespSafe@state.mn.us"><u>Health.RespSafe@state.mn.us</u></a>.
        <br>
        Questions about the VaxCheck application should be sent to the VaxCheck Team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.
      </p>
    </div>
    <div style="margin-top:45px; font-weight:700">
      <router-link :to="{name: 'respSafeReg'}">
        <b-button id="btnHome" class="bg-mdh" role="button">Return Home</b-button>
      </router-link>
    </div>
  </b-container>
</template>

<script>

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";

export default {
  name: 'respSafeSubmissionConfirmation',
  components: {BaseFacilitySelect},
  data: () => ({
    date: new Date()

  }),

  created() {
    this.getCurrentFacility()
  },
  methods: {
    getCurrentFacility(){
      return this.$store.state.selectedFacility.facilityName
    },
  }
}
</script>
